import React, { useRef } from "react"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type { ReducedGeneralContentBlockWithLiveText } from "types/cms"
import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"
import { DeprecatedChakraButtonCta } from "packages/acquisition/components/chakra-components/CMS/ButtonCta"
import { ImageOrVideo } from "./ImageOrVideo"
import { RichTextFlat } from "../RichTextFlat"

import { defaultBlock } from "./GeneralContentBlockWithLiveText.fixtures"

import {
  containerColors,
  contentAlign,
  copyWrapper,
  headingClass,
  largeHeadingClass,
  subtitleClass,
  subCtaLink,
} from "./GeneralContentBlockWithLiveText.css"
import { IconsContainer } from "../IconsContainer"

const { cta: defaultCta, icons: defaultIcons } = defaultBlock

type Props = CMSPageProps & ReducedGeneralContentBlockWithLiveText

const HeaderSize = ({ headingSize, heading, styleClass }) => {
  const TagSize = headingSize
  return <TagSize className={styleClass}>{heading}</TagSize>
}

export const GeneralContentBlockWithLiveText: React.FC<Props> = ({
  title,
  showSubtitle,
  subtitle,
  icons,
  imageRef,
  cta,
  link,
  imagePosition,
  trackingModule,
  showRichText,
  richTextBody,
  showIcons,
  showCta,
  showSubCta,
  backgroundColour,
  titleSize,
}) => {
  const isAlignLeft = imagePosition === "Left"

  const ref = useRef(null)

  const ctaToPass = cta || defaultCta

  const { modulePosition } = trackingModule

  return (
    <div
      className={containerColors[backgroundColour || "Lightest Pink"]}
      ref={ref}
      id={cleanTitle(title)}
      data-testid={cleanTitle(title)}
    >
      <div className={contentAlign[isAlignLeft ? "Left" : "Right"]}>
        <ImageOrVideo
          imageOrVideo={imageRef}
          title={title}
          modulePosition={modulePosition}
        />
        <div className={copyWrapper}>
          <HeaderSize
            headingSize={modulePosition === 1 ? "h1" : "h2"}
            heading={title || "Title"}
            styleClass={
              titleSize === "Large" ? `${largeHeadingClass}` : headingClass
            }
          />
          {showSubtitle !== false && (
            <p className={subtitleClass}>{subtitle || "Subtitle"}</p>
          )}
          {showRichText !== false && (
            <RichTextFlat content={richTextBody ?? "Default Body"} />
          )}
          {showIcons !== false && (
            <IconsContainer iconContainer={icons ?? defaultIcons} />
          )}
          {showCta !== false && (
            <DeprecatedChakraButtonCta
              {...ctaToPass}
              trackingModule={trackingModule}
            />
          )}
          {showSubCta !== false && (
            <a
              className={subCtaLink}
              href={link?.href || "/"}
              title={link?.title || "Default Link"}
              onClick={() =>
                cmsPageClick({
                  ...trackingModule,
                  moduleContentUrl: link?.href || "/",
                })
              }
            >
              {link?.title || "Sub CTA Link"}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
